/**
 * Splits a date into day/month/year.
 *
 * @param {string} date The date.
 * @returns {{month: string, year: string, day: string}}
 */
export const splitDate = date => {
  if (!date) {
    return {
      day: '',
      month: '',
      year: '',
    };
  }

  const dateObject = new Date(date);

  return {
    day: String(dateObject.getDate()).padStart(2, '0'),
    month: String(dateObject.getMonth() + 1).padStart(2, '0'),
    year: String(dateObject.getFullYear()).padStart(4, '0'),
  };
};
